import api_fetch  from "../utils/api_fetch"
import { storageHandler } from '../utils/storage_handler';

const gmailService = {
    getMessages: async function(page = 1, pageSize = 50, keyword = '', dateFrom = '', dateTo = '', sender = '', hasAttachment = null) {
        const params = { page, pageSize, keyword };
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (sender) params.sender = sender;
        if (hasAttachment !== null) params.hasAttachment = hasAttachment ? '1' : '0';
        return (await (api_fetch.get(`/v1/gmail/messages`, {
            "Authorization": `Bearer ${storageHandler.localStorageGet('token')}`
        }, params, "", {}))).json();
    }    
}

export default gmailService;